import React from 'react';
import formatDuration from '../../../utils/formatDuration';
import type { CheckSegmentStep } from '../../../types';
import StepCardFrame from './StepCardFrame';
import * as styles from './journey.module.css';
type Props = { step: CheckSegmentStep; hasLegalCycle: boolean };
const CheckSegmentCard: React.FC<Props> = ({ step, hasLegalCycle }) => (
    <StepCardFrame
        id={step.id}
        title="Check segment"
        kind="check"
        action={hasLegalCycle ? <span className={styles.badge}>↻ Repeats</span> : undefined}
    >
        <p className={styles.description}>
            {step.segment_id != null ? `Matches segment #${step.segment_id}` : 'Choose a segment'}
        </p>
        {step.wait_for && (
            <p className={styles.description}>Wait {formatDuration(step.wait_for)}</p>
        )}
    </StepCardFrame>
);
export default CheckSegmentCard;
